import React, { Component } from 'react';



class Home extends Component{

    skillsUsed(){
        return(
            <div className='row skill-list'>                    
                    <div className='col'>React</div>
                    <div className='col'>Redux</div>
                    <div className='col'>Thunk</div>
                    <div className='col'>Firebase</div>
                    <div className='col'>Bootstrap</div>
                    <div className='col'>AWS S3</div>
                    <div className='col'>Node.js</div>
                    <div className='col'>MongoDB</div>
                    <div className='col'>Bash</div>
                    <div className='col'>TravisCI</div>
                    <div className='col'>DevOps</div>
                </div>
        )
    }

    githubSource(){
        return(
            <div className='source'>
                <a
                 href='https://github.com/sohammondal/react-mini-projects' 
                 title='GitHub Repo'
                 rel='noopener noreferrer'
                 target="_blank"><i className='fas fa-code'></i></a>
            </div>
        )
    }

    render(){
        return(
            <div className='App container'>
                <div >This app displays my mini react projects! </div>
                {this.skillsUsed()}
                {this.githubSource()}
            </div>
        )
    }
}

export default Home;


// WEBPACK FOOTER //
// ./src/components/Home.jsx